import { REMOTE_CLIENTS_TABLE_COLUMNS } from './remote-clients';

export enum FINAL_USERS_TABLE_COLUMNS {
    EXPANDER = 'Expander',
    FIRST_NAME = 'FirstName',
    LAST_NAME = 'LastName',
    EMAIL = 'Email',
    ID = 'Id',
    MAX_REMOTES = 'MaxRemotes',
    ACTIONS = 'Actions'
}

export const FINAL_USERS_COLUMNS = [
    {name: 'FIRST_NAME', value: FINAL_USERS_TABLE_COLUMNS.FIRST_NAME},
    {name: 'LAST_NAME', value: FINAL_USERS_TABLE_COLUMNS.LAST_NAME},
    {name: 'EMAIL', value: FINAL_USERS_TABLE_COLUMNS.EMAIL},
];

export const FINAL_USERS_TABLE_HEADER = [
    FINAL_USERS_TABLE_COLUMNS.EXPANDER,
    FINAL_USERS_TABLE_COLUMNS.FIRST_NAME,
    FINAL_USERS_TABLE_COLUMNS.LAST_NAME,
    FINAL_USERS_TABLE_COLUMNS.EMAIL,
    FINAL_USERS_TABLE_COLUMNS.ID,
    FINAL_USERS_TABLE_COLUMNS.MAX_REMOTES,
    FINAL_USERS_TABLE_COLUMNS.ACTIONS,
];

export const FINAL_USERS_PROFILES_TABLE_HEADER = [
    FINAL_USERS_TABLE_COLUMNS.FIRST_NAME,
    FINAL_USERS_TABLE_COLUMNS.LAST_NAME,
    FINAL_USERS_TABLE_COLUMNS.EMAIL,
    FINAL_USERS_TABLE_COLUMNS.ID,
    FINAL_USERS_TABLE_COLUMNS.ACTIONS,
];

export const FINAL_USERS_PAGE_SIZE_OPTIONS = [10, 15, 20, 25];
export const FINAL_USERS_PAGE_DEFAULT_SIZE = 10;

export const FINAL_USERS_REMOTE_CLIENTS_COLUMNS = [
    { name: 'LICENSE_ID', value: REMOTE_CLIENTS_TABLE_COLUMNS.LICENSE_ID },
    { name: 'DESCRIPTION', value: REMOTE_CLIENTS_TABLE_COLUMNS.DESCRIPTION },
    { name: 'CLIENT_ID', value: REMOTE_CLIENTS_TABLE_COLUMNS.CLIENT_ID },
    { name: 'ENABLED', value: REMOTE_CLIENTS_TABLE_COLUMNS.ENABLED }
];

export const FINAL_USERS_REMOTE_CLIENTS_TABLE_HEADER = [
    REMOTE_CLIENTS_TABLE_COLUMNS.LICENSE_ID,
    REMOTE_CLIENTS_TABLE_COLUMNS.DESCRIPTION,
    REMOTE_CLIENTS_TABLE_COLUMNS.CLIENT_ID,
    REMOTE_CLIENTS_TABLE_COLUMNS.ENABLED,
    FINAL_USERS_TABLE_COLUMNS.ACTIONS,
];
